import { defineType } from 'sanity';

export const carouselSection = defineType({
    name: 'carouselSection',
    title: 'Carousel section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'items',
            title: 'Carousel Items',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'title',
                            title: 'Title',
                            type: 'localizedString',
                        },
                        {
                            name: 'content',
                            title: 'Content',
                            type: 'localizedString',
                        },
                        {
                            name: 'image',
                            title: 'Image',
                            type: 'seoOptimizedImageUrl',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Carousel Section: ${title['en'] || title['sr']}`,
            };
        },
    },
});
